import { useAdministrativeContext } from "../../../../../../pages/administrativePanel/administrativePanelContext"
import { useState, useEffect, useCallback } from "react"
import { api } from "../../../../../../services/api"
import { SpaceLoader } from "../../../../../loaders/spaceLoader"
import { GenericHorizontalBar } from "../../genericHorizontalBar"
import { toast } from "react-toastify"
import { useAuth } from "../../../../../../context/AuthContext"


export function ProductsGraphic() {
    const [productsDatasForGraphic, setProductsDatasForGraphic] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    const { 
        startDate, 
        endDate, 
        listBusinessToFilter,
        listSalesChannelsId 
    } = useAdministrativeContext()

    const { signOut } = useAuth()
   
    const fetchData = useCallback(async () => {
        setIsLoading(true)

        let obj = {
            startDate: startDate,
            endDate: endDate,
            business: listBusinessToFilter,
            salesChannels: listSalesChannelsId
        }

  
        try{
            await api.post('/getProductsGraphic' , obj, {
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('@Inoveclube:token')
                }
            }).then(response => setProductsDatasForGraphic(response.data))
            setIsLoading(false)

        }catch(error){
            if(error.response){
                if(error.response.status === 401 || error.response.status === 500){
                    signOut()
                    toast.warning('Sua sessão foi expirada')
                }else{
                    toast.error(error.response.data.message)
                }
            }else{
                toast.error(error.message)
            }        
        }
    }, [endDate, signOut, startDate, listBusinessToFilter, listSalesChannelsId])
    
    
    useEffect(() => {
        let subscribed = true

        if(subscribed && startDate !== '' && endDate !== '')
            fetchData()

        return () => (subscribed = false)
    }, [fetchData, startDate, endDate])


    
    if(isLoading){
        return <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" /> 
    }else{
        return( 
            <>
                {
                    productsDatasForGraphic.length > 0 ?
                    <GenericHorizontalBar datasForGraphic={productsDatasForGraphic} animationBar={true}/>
                    :<p className="withoutInformations">Nenhuma informação</p>
                }

            </>
        )
    }
}